
export const snackBarReducerConstant = {
  SNACKBAR_SUCCESS: 'SNACKBAR_SUCCESS',
  SNACKBAR_FAILURE: 'SNACKBAR_FAILURE',
  SNACKBAR_CLEAR: 'SNACKBAR_CLEAR'
};

export const scriptsReducerConstants = {
  FETCH_SCRIPTS: 'FETCH_SCRIPTS',
  FETCH_SCRIPTS_ERROR: 'FETCH_SCRIPTS_ERROR',
  GET_AUTH_SCRIPTS_REQUEST: 'GET_AUTH_SCRIPTS_REQUEST',
  GET_AUTH_SCRIPTS_FAILURE: 'GET_AUTH_SCRIPTS_FAILURE',
};
